import { buildModule } from '../utils';

import lazy from './lazy';
import detail from './detail';
import list from './list';

export default buildModule()
	.withSubmodules({
		lazy,
		detail,
		list,
	});
